import React, { useEffect, useState } from "react";
import "./TimesheetNotification.css";

const TimesheetNotification = ({
  isVisible,
  type = "success",
  title,
  message,
  duration = 5000,
  onClose,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
      setIsClosing(false);
    }, 300); // Время анимации закрытия
  };

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return "✅";
      case "error":
        return "❌";
      case "warning":
        return "⚠️";
      case "info":
        return "ℹ️";
      default:
        return "ℹ️";
    }
  };

  return (
    <div
      className={`timesheet-notification timesheet-notification--${type} ${
        isClosing ? "timesheet-notification--closing" : ""
      }`}
    >
      <div className="timesheet-notification__content">
        <div className="timesheet-notification__icon">{getIcon()}</div>
        <div className="timesheet-notification__text">
          {title && (
            <div className="timesheet-notification__title">{title}</div>
          )}
          {message && (
            <div className="timesheet-notification__message">{message}</div>
          )}
        </div>
        <button
          className="timesheet-notification__close-btn"
          onClick={handleClose}
          type="button"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default TimesheetNotification;
